import React from 'react'
import PropTypes from 'prop-types'
import { colors, presets, themeStyles } from '../utils/theme'
import { getCurrentDateSlashFormat, getDTRStringFromLocation } from '../utils/helpers'
import CascadeLink from '../components/CascadeLink'
import Metadata from '../components/Metadata'
import { FaCheck } from 'react-icons/fa';
import FeaturedIn from '../components/FeaturedIn'
import { HTMLContent } from '../components/Content'
import { graphql } from 'gatsby'

import { FaFacebook } from 'react-icons/fa'
import logo from '../img/logo-nopad.svg'
import lendingTree from '../img/lt-logo-bk.svg'
import lendingTreeCertifiedBadge from '../img/lendingTreeBadgeCertifiedLender2022.png'
import lendingTreeTop10Lender from '../img/lending-tree-top-10-lender-q4-2021.png'
import smartAssetLogo from '../img/smartassetlogo.png'
import ratekickLogo from '../img/ratekick.svg'
import bbb from '../img/bbb.svg'
import trustPilot from '../img/trustpilot-white.png'
import equalHousing from '../img/equal-housing_white.svg'
import truebillLogo from '../img/icons/truebill.svg'
import sofiLogo from '../img/icons/SoFi.png'
import aaaLogo from '../img/icons/American_Automobile_Association_Logo.png'
import earnestLogo from '../img/icons/earnest_logo.png'
import doorvest from '../img/icons/doorvest_color.png'
import zillow from '../img/icons/zillow_logo.png'
import bankrate from '../img/icons/bankrate_logo.svg'
import creditSesame from '../img/icons/creditsesame_logo.png'
import lanternSofiLogo from '../img/icons/lanternSofiLogo.svg'
import freerateupdateLogo from '../img/icons/freerateupdate.svg'
import assuranceLogo from '../img/icons/assuranceiq-logo.svg'
import { WhyLoanSnap } from '../components/WhyLoanSnap'
import { rhythm } from '../utils/typography'

const contentWidth = {
  width: "100%",
  maxWidth: '1000px',
  margin: '0 auto',
  padding: '0 20px',
}

const styles = {
  headerOuter: {
    borderBottom: `1px solid ${colors.lightGrey}`,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    ...contentWidth,
    padding: '10px 20px',
    position: 'relative',
    [presets.Tablet]: {
      flexDirection: 'row',
      alignItems: 'space-between',
    }
  },
  headerWithFacebook: {
    margin: 'auto',
    width: '100%',
    [presets.Tablet]: {
      marginLeft: rhythm(0.2),
      maxWidth: '30rem',
    },
    [presets.Desktop]: {
      marginLeft: rhythm(5),
    },
    [presets.Hd]: {
      marginLeft: rhythm(10),
    }
  },
  mainLogo: {
    maxHeight: '25px',
    margin: 0,
    marginTop: '5px',
    [presets.Mobile]: {
      maxHeight: '30px',
    }
  },
  logoLine: {
    height: '45px',
    borderLeft: `1px solid ${colors.lightGrey}`,
    margin: '0 20px',
  },
  logoHolder: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '5px',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    ...contentWidth,
    maxWidth: '1000px',
  },
  onlySowTitlesContentContainer: {
    paddingTop: '4rem',
    paddingBottom: '5rem',
    [presets.Tablet]: {
      paddingTop: '10rem',
      paddingBottom: '12rem',
    }
  },
  topRow: {
    backgroundColor: colors.darkGreen,
    display: 'flex',
    width: '100%',
    paddingTop: '20px',
  },
  h1: {
    color: 'white',
    marginBottom: 0,
    fontSize: '26px',
    lineHeight: '25px',
    fontWeight: 600,
    [presets.Tablet]: {
      fontSize: '36px',
      lineHeight: '45px',
    }
  },
  twoTitles: {
    fontSize: '18px',
    fontWeight: 300,
    fontFamily: 'Arial',
    [presets.Tablet]: {
      fontSize: '25px',
    }
  },
  partnerNameInTitle: {
    fontSize: '23px',
    [presets.Tablet]: {
      fontSize: '30px',
    }
  },
  subtext: {
    margin: '0',
    color: 'white',
    fontWeight: 300,
    fontSize: '18px',
    marginTop: '5px',
    marginBottom: '5px',
  },
  subtextLine: {
    marginBottom: '5px',
  },
  button: {
    borderRadius: '5px',
    textDecoration: 'none',
    textAlign: 'center',
    marginBottom: '30px',
    padding: '0 8px 0 8px',
    fontSize: '18px',
    backgroundColor: colors.shamrock,
    color: 'white',
    ':hover': {
      // hack to make dark hover for any color
      boxShadow: 'inset 0 0 0 99999px rgba(0,0,0,0.2)',
    },
    width: '100%',
    maxWidth: '296px',
    height: '43px',
    display: 'flex',
    flexDirection: 'column',
    alignItem: 'center',
    justifyContent: 'center',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    alignSelf: 'stretch',
  },
  halfRow: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  phone: {
    width: '100%',
    maxWidth: '316px',
    margin: 0,
  },
  secondRow: {
    backgroundColor: colors.tan,
    color: colors.grey,
    paddingBottom: '30px',
  },
  calloutBox: {
    padding: '15px 30px',
    borderStyle: 'double',
    borderColor: '#f1592a',
    margin: '40px 10px',
  },
  calloutTitle: {
    fontSize: '28px',
    textAlign: 'center',
  },
  calloutSubText: {
    fontSize: '20px',
    textAlign: 'center',
    marginBottom: 0,
    paddingBottom: 0,
    fontWeight: 600,
  },
  checkRow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginBottom: '30px',
    [presets.Tablet]: {
      alignSelf: 'stretch',
      flexDirection: 'row',
      justifyContent: 'space-around',
    },
  },
  checkItemHolder: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '20px',
    [presets.Tablet]: {
      margin: 0
    },
  },
  checkmark: {
    marginRight: '10px',
  },
  checkText: {
    fontSize: '22px',
    fontWeight: 600,
    maxWidth: '220px',
  },
  footerContainer: {
    backgroundColor: '#BBB8B8',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },
  footerInner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    ...contentWidth,
    padding: '10px',
    marginTop: '20px',
    [presets.Tablet]: {
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    [presets.Desktop]: {
      flexWrap: 'nowrap'
    }
  },
  footerLink: {
    fontSize: '12px',
    color: 'white',
    textDecoration: 'none',
  },
  footerLinksContainer: {
    display: 'flex',
    margin: '1em 0',
    flexDirection: 'row',
    alignItems: 'center',
    [presets.Tablet]: {
      margin: 0,
    },
    '& a + a': {
      marginLeft: '30px'
    }
  },
  trustIconHolder: {
    display: 'flex',
    flexDirection: 'row',
    alignItem: 'center',
    justifyContent: 'center',
  },
  disclaimerText: {
    fontSize: '12px',
    color: 'white',
  },
  copyrightText: {
    margin: '0 0 1rem',
    color: 'white',
    fontSize: '10px',
    textAlign: 'left',
    '& a': {
      textDecoration: 'underline'
    },
  },
  abTrustpilotLendingtree: {
    display: 'block',
    alignItems: 'center',
    marginLeft: '-15px',
    transform: 'scale(0.82)',
    transformOrigin: 'top left',
    '& img': {
      margin: 0,
      maxHeight: '60px',
    },
    [presets.Tablet]: {
      display: 'flex',
      marginBottom: '10px',
      transform: 'none',
      '& img': {
        display: 'none'
      }
    }
  },
  abTrustpilotLendingtreeAwards: {
    display: 'flex',
    alignItems: 'center',
    transformOrigin: 'top left',
    padding: '0 5px',
    '& img': {
      margin: '0 10px',
      maxHeight: '60px',
    },
  },
  abHeaderLTLogos: {
    display: 'none',
    position: 'absolute',
    top: '15px',
    right: '15px',
    [presets.Tablet]: {
      display: 'flex'
    }
  },
  abHeaderLTCertified: {
    margin: 0,
    maxHeight: '100px',
  },
  abHeaderLTTop10Lender: {
    margin: '0 16px',
    maxHeight: '90px',
  },
  spacer: {
    height: '3rem',
    backgroundColor: colors.darkGreen,
  },
  facebookIcon: {
    marginTop: '0.4rem',
  }
}

const CURRENT_YEAR = new Date().getFullYear()

const partners = {
  bankrate: 'bankrate',
  zillow: 'zillow', 
  doorvest: 'doorvest',
  lanternSofi: 'lanternSofi',
  aaa: 'aaa',
  sofi: 'sofi',
  ratekick: 'ratekick',
  truebill: 'truebill',
  smartAsset: 'smartAsset',
  lendingTree: 'lendingTree',
  creditSesame: "creditSesame",
  assurance: 'assurance',
  freerateupdate: 'freerateupdate',
  earnest: 'earnest',
  facebookNavBar: 'facebookNavBar'
}

export const Header = ({ showPartnerLogo, partnerLogo }) => (
    <div css={styles.headerOuter}>
      <div css={[styles.headerContainer, partnerLogo === partners.facebookNavBar && styles.headerWithFacebook]}>
        <div css={styles.logoHolder}>
          {showPartnerLogo && partnerLogo === partners.lanternSofi && <img alt="Lantern+Sofi" src={lanternSofiLogo} css={{...styles.mainLogo, maxHeight: '20px', [presets.Mobile]: {maxHeight: '55px', marginBottom: 0, }}} />}
          {showPartnerLogo && partnerLogo === partners.sofi && <img alt="Sofi" src={sofiLogo} css={{...styles.mainLogo, [presets.Mobile]: {maxHeight: '55px', marginBottom: 0, }}} />}
          {showPartnerLogo && partnerLogo === partners.aaa && <img alt="Aaa" src={aaaLogo} css={{...styles.mainLogo, [presets.Mobile]: {maxHeight: '55px', marginBottom: 0, }}} />}
          {showPartnerLogo && partnerLogo === partners.earnest && <img alt="Earnest" src={earnestLogo} css={{...styles.mainLogo, [presets.Mobile]: {maxHeight: '35px', marginBottom: 0, }}} />}
          {showPartnerLogo && partnerLogo === partners.ratekick && <img alt="RateKick" src={ratekickLogo} css={{...styles.mainLogo, [presets.Mobile]: {maxHeight: '35px', marginBottom: 0, }}} />}
          {showPartnerLogo && partnerLogo === partners.truebill && <img alt="Truebill" src={truebillLogo} css={{...styles.mainLogo, [presets.Mobile]: {maxHeight: '40px', marginBottom: 0, }}} />}
          {showPartnerLogo && partnerLogo === partners.smartAsset && <img alt="smartAsset" src={smartAssetLogo} css={{...styles.mainLogo, maxHeight: '16px', [presets.Mobile]: {maxHeight: '25px', marginBottom: '5px'}}} />}
          {showPartnerLogo && partnerLogo === partners.zillow && <img alt="Zillow" src={zillow} css={{...styles.mainLogo, maxHeight: '16px', [presets.Mobile]: {maxHeight: '25px', marginBottom: '5px'}}} />}
          {showPartnerLogo && partnerLogo === partners.bankrate && <img alt="Bankrate" src={bankrate} css={{...styles.mainLogo, maxHeight: '16px', [presets.Mobile]: {maxHeight: '25px', marginBottom: '5px'}}} />}
          {showPartnerLogo && partnerLogo === partners.creditSesame && <img alt="CreditSesame" src={creditSesame} css={{...styles.mainLogo, [presets.Mobile]: {maxHeight: '45px'}}} />}
          {showPartnerLogo && partnerLogo === partners.lendingTree && <img alt="lendingTree" src={lendingTree} css={{...styles.mainLogo, [presets.Mobile]: {maxHeight: '45px'}}} />}
          {showPartnerLogo && partnerLogo === partners.doorvest && <img alt="doorvest" src={doorvest} css={{...styles.mainLogo, maxHeight: '14px', [presets.Mobile]: {maxHeight: '20px'}}} />}
          {showPartnerLogo && partnerLogo === partners.freerateupdate &&<img css={{...styles.mainLogo, [presets.Mobile]: { maxHeight: '30px', marginBottom: 0 }}} alt="FreeRateUpdate" src={freerateupdateLogo} />}
          {showPartnerLogo && partnerLogo === partners.assurance &&<img css={{ ...styles.mainLogo, [presets.Mobile]: { maxHeight:  '30px', marginBottom: 0 }}} alt="Assurance" src={assuranceLogo} />}
          {showPartnerLogo && partnerLogo === partners.facebookNavBar &&<CascadeLink analyticsTargetName='Social Facebook' target="_blank" rel="noopener noreferrer" href='https://facebook.com/loansnap' style={styles.facebookIcon}><FaFacebook color={colors.facebookBlue} size="45" /></CascadeLink>}
          {showPartnerLogo && <div css={styles.logoLine} />}
          <img alt="logo" src={logo} css={[styles.mainLogo, {maxHeight: (showPartnerLogo && partnerLogo === partners.lanternSofi) ? '20px' : null }]} />
        </div>
        {(showPartnerLogo && partnerLogo === partners.lendingTree) &&
          <div css={styles.abHeaderLTLogos}>
            <a href='https://www.lendingtree.com/reviews/mortgage/loansnap/39777117'>
              <img css={styles.abHeaderLTTop10Lender} alt="Lending Tree Top-10 Lender Customer Satisfaction Q4 2021" src={lendingTreeTop10Lender} />
              <img css={styles.abHeaderLTCertified} alt="Lending Tree Certified Lender" src={lendingTreeCertifiedBadge} />
            </a>
          </div>
        }
      </div>
    </div>
)

export const Footer = ({disclaimerText, hideTrustPilot=false}) => {
  // ugly but a way to insert dynamic templated text
  const disclaimerTextWithDate = JSON.parse(JSON.stringify(disclaimerText).replace('{{date}}', getCurrentDateSlashFormat()))
  return (
    <div css={styles.footerContainer}>
      <div css={styles.footerInner}>
        <div css={styles.footerLinksContainer}>
          <CascadeLink
            css={styles.footerLink}
            to="/legal/privacy-policy"
            analyticsTargetName='Privacy Policy'
          >
            Privacy Policy
          </CascadeLink>
          <CascadeLink
            css={styles.footerLink}
            to="/legal/terms-and-conditions"
            analyticsTargetName='Terms and Conditions'
          >
            Terms of use
          </CascadeLink>
        </div>
        <div css={styles.trustIconHolder}>
          <img alt="equalHousing" src={equalHousing} css={{ height: '30px', margin: 0}} />
          <img alt="bbb" src={bbb} css={{ height: '30px', margin: 0, marginLeft: '30px'}} />
          {!hideTrustPilot && <img alt="trustPilot" src={trustPilot} css={{ height: '30px', margin: 0, marginLeft: '30px'}} />}
        </div>
      </div>
      <div css={styles.footerInner}>
        <div css={styles.disclaimerText}>
          {disclaimerText && <HTMLContent content={disclaimerTextWithDate} isLinkSameColor={true} /> }
          <div css={styles.copyrightText}>
            &copy; {CURRENT_YEAR} LoanSnap, Inc. All rights reserved. LoanSnap, Inc. is a direct lender. NMLS #76967 | <CascadeLink href="https://www.nmlsconsumeraccess.org/" analyticsTargetName="Footer NMLS" css={{color: colors.white, textDecoration: 'none'}}>NMLS access page</CascadeLink>
            &nbsp; Lending services provided by LoanSnap, Inc., a subsidiary of LoanSnap Holdings, Inc. Note: any references to LoanSnap on this website correspond to the legal entity LoanSnap, Inc.
          </div>
        </div>
      </div>
    </div>
  )
}
const LendingTreeLandingTemplate = ({
  title,
  partnerNameInTitle,
  secondTitle,
  onlySowTitles,
  hideTrustPilot,
  subTextLines,
  loMessage,
  buttonText,
  buttonTextSecond,
  buttonTextThird,
  calloutTitle,
  calloutSubText,
  checks,
  targetUrl,
  targetUrlSecond,
  targetUrlThird,
  disclaimerText,
  helmet,
  showCallout,
  showPartnerLogo,
  showSecondRow,
  partnerLogo,
}) => {
  const renderTitle = () => {
    return partnerNameInTitle ?
    (<h1 css={[styles.h1, onlySowTitles&&styles.twoTitles]}>{title}, <span css={styles.partnerNameInTitle}>{partnerNameInTitle}</span></h1>) :
    (<h1 css={[styles.h1, onlySowTitles&&styles.twoTitles]}>{title}</h1>)
  }

  return (
    <div css={{ display: 'flex', flex: 1, flexDirection: 'column', minHeight: '100vh'}}>
      {helmet || ''}
      <Header
        showPartnerLogo={showPartnerLogo}
        partnerLogo={partnerLogo}
      />
      <div css={styles.topRow}>
        <div css={[styles.contentContainer, onlySowTitles&&styles.onlySowTitlesContentContainer]}>
          <div css={styles.row}>
            <div css={styles.halfRow}>
              {renderTitle()}
              {secondTitle && <h1 css={[styles.h1, onlySowTitles&&[styles.twoTitles, {marginBottom: '5rem'}]]}>{secondTitle}</h1>}
              <div css={styles.subtext}>
                {subTextLines && subTextLines.map((l, i)=> <div css={styles.subtextLine} key={i}>{l.text}</div>)}
              </div>
              <CascadeLink
                css={[styles.button, (showPartnerLogo && partnerLogo === partners.lendingTree && {margin: '20px 0'}) || (buttonTextSecond && {margin: '10px 0'})]}
                href={targetUrl}
                analyticsTargetName='CTA Button'
              >
                { buttonText || "Get Started"}
              </CascadeLink>
              {buttonTextSecond && <CascadeLink
                css={[styles.button, {margin: '10px 0'}]}
                href={targetUrlSecond}
                analyticsTargetName='CTA Button Second'
              >
                { buttonTextSecond || "Get Started"}
              </CascadeLink>}
              {buttonTextThird && <CascadeLink
                css={[styles.button, {margin: '10px 0 40px 0'}]}
                href={targetUrlThird}
                analyticsTargetName='CTA Button Third'
              >
                { buttonTextThird || "Get Started"}
              </CascadeLink>}
            </div>
            {(subTextLines || loMessage) && <WhyLoanSnap subTextLines={subTextLines} loMessage={loMessage}/>}
          </div>
        </div>
      </div>

      {!showSecondRow && <div css={styles.spacer}/>}
      {showSecondRow && <div css={styles.secondRow}>
        <div css={styles.contentContainer}>
          {showCallout &&
            <div css={styles.calloutBox}>
              <h3 css={styles.calloutTitle}>
                {calloutTitle}
              </h3>
              <p css={styles.calloutSubText}>
                {calloutSubText}
              </p>
            </div>
          }
          {checks && <div css={[styles.checkRow, {marginTop: showCallout ? '0' : '40px'}]}>
            {checks && checks.map(c => (
              <div key={c.text} css={styles.checkItemHolder}>
                <FaCheck color={colors.shamrock} size={35} css={styles.checkmark}/>
                <div css={styles.checkText}>{c.text}</div>
              </div>
            ))}
          </div>}
        </div>
        <FeaturedIn />
      </div>}
      <Footer disclaimerText={disclaimerText} hideTrustPilot={hideTrustPilot}/>
    </div>
  )
}

LendingTreeLandingTemplate.propTypes = {
  title: PropTypes.string,
  partnerNameInTitle: PropTypes.string,
  secondTitle: PropTypes.string,
  onlySowTitles: PropTypes.bool,
  hideTrustPilot: PropTypes.bool,
  subTextLines: PropTypes.array,
  loMessage: PropTypes.string,
  buttonText: PropTypes.string,
  buttonTextSecond: PropTypes.string,
  buttonTextThird: PropTypes.string,
  calloutTitle: PropTypes.string,
  calloutSubText: PropTypes.string,
  checks: PropTypes.array,
  targetUrl: PropTypes.string,
  targetUrlSecond: PropTypes.string,
  targetUrlThird: PropTypes.string,
  showCallout: PropTypes.bool,
  showPartnerLogo: PropTypes.bool,
  showSecondRow: PropTypes.bool,
  partnerLogo: PropTypes.oneOf([partners.creditSesame, partners.bankrate, partners.zillow, partners.doorvest, partners.lanternSofi, partners.aaa, partners.sofi, partners.ratekick, partners.truebill, partners.smartAsset, partners.lendingTree]),
}

const LendingTreeLandingPage = ({ data, location }) => {
  const { markdownRemark: post } = data
  let textToDisplay = ''

  if (typeof window != 'undefined') {
    textToDisplay = getDTRStringFromLocation(location) || post.frontmatter.title
  }

  return (
    <LendingTreeLandingTemplate
      helmet={
        <Metadata
          title={post.frontmatter.title}
        />
      }
      title={textToDisplay}
      partnerNameInTitle={post.frontmatter.partnerNameInTitle}
      secondTitle={post.frontmatter.secondTitle}
      onlySowTitles={post.frontmatter.onlySowTitles}
      hideTrustPilot={post.frontmatter.hideTrustPilot}
      subTextLines={post.frontmatter.subTextLines}
      loMessage={post.frontmatter.loMessage}
      buttonText={post.frontmatter.buttonText}
      buttonTextSecond={post.frontmatter.buttonTextSecond}
      buttonTextThird={post.frontmatter.buttonTextThird}
      calloutTitle={post.frontmatter.calloutTitle}
      calloutSubText={post.frontmatter.calloutSubText}
      checks={post.frontmatter.checks}
      targetUrl={post.frontmatter.targetUrl}
      targetUrlSecond={post.frontmatter.targetUrlSecond}
      targetUrlThird={post.frontmatter.targetUrlThird}
      disclaimerText={post.htmlAst}
      showCallout={post.frontmatter.showCallout}
      showPartnerLogo={post.frontmatter.showPartnerLogo}
      partnerLogo={post.frontmatter.partnerLogo}
      showSecondRow={post.frontmatter.showSecondRow}
    />
  )
}

LendingTreeLandingPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
}

export default LendingTreeLandingPage

export const pageQuery = graphql`
  query LendingTreeLandingPageByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      htmlAst
      frontmatter {
        title
        partnerNameInTitle
        secondTitle
        onlySowTitles
        hideTrustPilot
        subTextLines {
          text
        }
        loMessage
        buttonText
        buttonTextSecond
        buttonTextThird
        calloutTitle
        calloutSubText
        checks {
          text
        }
        targetUrl
        targetUrlSecond
        targetUrlThird
        showCallout
        showPartnerLogo
        showSecondRow
        partnerLogo
      }
    }
  }
`